import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'tabler-react';

const propTypes = {
    color: PropTypes.string.isRequired
};

const defaultProps = {
    show: false,
    text: null
};

const CardAlert = props => {
    return (
        <React.Fragment>
            {
                props.children &&
                <Card.Alert color={props.color}>{props.children}</Card.Alert>
            }
        </React.Fragment>
    );
};

CardAlert.propTypes = propTypes;
CardAlert.defaultProps = defaultProps;

export default CardAlert;